'use strict';

import $ from 'jquery';
import { viewport } from './utilities/viewport';
import { debounce } from './utilities/debounce';

const floatSearchMax = 1367;
const floatSearchMin = 1070;

let headerMenu = $('#block-ia-mainnavigation .menu-level-0');
let	headerExpandedMenuItem = headerMenu.find('> .menu-item--expanded');
let	headerMenuItem = headerMenu.find('> .menu-item');

let	headerExpandedMenuItemLink = headerExpandedMenuItem.find('> a');
let headerSearchIcon = $('#block-ia-exposedformcontent-searchpage-1 .form-actions');
let headerSearchInput = $('#block-ia-exposedformcontent-searchpage-1 .form-item-keys');

let headerSearchIconHomepage = $('#block-exposedformcontent-searchpage-1-4 .form-actions');
let headerSearchInputHomepage = $('#block-exposedformcontent-searchpage-1-4 .form-item-keys');


let sideMenu = $('.region-primary-menu');
let sideMenuIconOpen = $('.header__menu-mobile-icon');
let sideMenuIconClose = $('#activated-menu-icon-wrapper');

//accessibility
let $primaryNavItems = $('.primary_menu-wrapper .menu-level-0 > .menu-item > a');
let $primaryNavItemsWithPopup = $('.primary_menu-wrapper .menu-level-0 > .menu-item.menu-item--expanded > a');
let $secondaryNavItems = $('.primary_menu-wrapper .menu-level-1 .menu-item > a');
let $allDropdownNavItems = $('.primary_menu-wrapper .menu-level-1 a');
let $primaryNavItemsNotFirst = $('.primary_menu-wrapper .menu-level-0 .menu-item:not(:first-child) > a');
let $secondaryNavItemsNotFirst = $('.primary_menu-wrapper .menu-level-1 .menu-item:not(:first-child) > a');

let $mobileMenuInput = $('.primary_menu-wrapper .region-primary-menu input, .region-primary-menu button');
let $mobileSearchInput = $('.region-primary-menu .au-text-input');
let $mobileCloseButton = $('.header__mobile-close-icon');


/* menu dropdown - desktop */
headerMenuItem.hover(function(){
	if ( viewport().width > 1070 ){
		if(!$(this).hasClass('expanded') && $(this).hasClass('menu-item--expanded')){
			closeAllMenuDropdown();
			$(this).add($(this).find('> ul')).addClass('expanded');
			$(this).find('> ul').stop().slideToggle(300);
		} else if($(this).hasClass('menu-item--expanded')){
			closeAllMenuDropdown();
		}
	}
})

/* search bar control */
headerSearchIcon.on('click', function(e){
	let windowWidth = viewport().width;
	if ( windowWidth < floatSearchMax && windowWidth > floatSearchMin && !headerSearchInput.hasClass('float')){
		e.preventDefault();
		headerSearchInput.toggleClass('float');
		headerSearchInput.find('input').focus();
	}
})

headerSearchIconHomepage.on('click', function(e){
	let windowWidth = viewport().width;
	if ( windowWidth < floatSearchMax && windowWidth > floatSearchMin && !headerSearchInputHomepage.hasClass('float')){
		e.preventDefault();
		headerSearchInputHomepage.toggleClass('float');
		headerSearchInputHomepage.find('input').focus();
	}
})


//close roll out search input field when pressing esc
headerSearchInput.find('input').on('keydown', function(e){
	var key = (e.keyCode ? e.keyCode : e.which);
	if (key == 27 ) {
		e.preventDefault();
		headerSearchInput.find('input').attr('tabindex','0');

		headerSearchInput.toggleClass('float');
		headerSearchIcon.find('input').focus();

	} else if(e.shiftKey && key==9){ //shift and tab
		if(viewport().width  < floatSearchMax && viewport().width  > floatSearchMin) {
			headerSearchInput.find('input').attr('tabindex','-1');
		}
		headerSearchInput.toggleClass('float');
	}

})

headerSearchInputHomepage.find('input').on('keydown', function(e){
	var key = (e.keyCode ? e.keyCode : e.which);
	if (key == 27 ) {
		e.preventDefault();
		headerSearchInputHomepage.find('input').attr('tabindex','0');

		headerSearchInputHomepage.toggleClass('float');
		headerSearchIconHomepage.find('input').focus();

	} else if(e.shiftKey && key==9){ //shift and tab
		if(viewport().width  < floatSearchMax && viewport().width  > floatSearchMin) {
			headerSearchInputHomepage.find('input').attr('tabindex','-1');
		}
		headerSearchInputHomepage.toggleClass('float');
	}

})


headerSearchIcon.find('input').on('keydown', function(e){
	var key = (e.keyCode ? e.keyCode : e.which);
	if (key == 9 ) {
		headerSearchInput.removeClass('float');
		if(viewport().width  < floatSearchMax && viewport().width  > floatSearchMin) {
			headerSearchInput.find('input').attr('tabindex','-1');
		}
	}
})


headerSearchIconHomepage.find('input').on('keydown', function(e){
	var key = (e.keyCode ? e.keyCode : e.which);
	if (key == 9 ) {
		headerSearchInputHomepage.removeClass('float');
		if(viewport().width  < floatSearchMax && viewport().width  > floatSearchMin) {
			headerSearchInputHomepage.find('input').attr('tabindex','-1');
		}
	}
})


$(document).on('click touchstart', function(e) {
	if (!$(e.target).closest("#block-ia-exposedformcontent-searchpage-1").length) {
		headerSearchInput.removeClass('float');
	}

	if (!$(e.target).closest("header .menu-level-0 > li").length) {
		closeAllMenuDropdown();
  }
});

$(document).on('click touchstart', function(e) {
	if (!$(e.target).closest("#block-exposedformcontent-searchpage-1-4").length) {
		headerSearchInputHomepage.removeClass('float');
	}

	if (!$(e.target).closest("header .menu-level-0 > li").length) {
		closeAllMenuDropdown();
  }
});



/* side menu - tablet */
sideMenuIconOpen.attr('aria-haspopup', 'true');
sideMenuIconOpen.attr('aria-expanded', 'false');

sideMenuIconOpen.on('click', function(){
	$(this).attr('aria-expanded', 'true');
	openMobileMenu();
	sideMenu.addClass('opened');
	$('body').addClass('overflow-hidden');
})

sideMenuIconClose.on('click', function(){
	sideMenuIconOpen.attr('aria-expanded', 'false');

	closeMobileMenu();
	sideMenu.removeClass('opened');
	$('body').removeClass('overflow-hidden');
	closeAllMenuDropdown();
})

headerExpandedMenuItemLink.on('click', function(e){
	if ( viewport().width <= 1070 ){
		e.preventDefault();
		if (!$(this).parent().hasClass('expanded')){
			closeAllMenuDropdown();
		}
		$(this).parent().add($(this).next()).toggleClass('expanded');
		$(this).parent().find('a').attr('tabindex', '0');
		$(this).next().stop().slideToggle(300);
		$(this).attr('aria-expanded', 'true');
	}
})

$(window).on('resize', debounce(function(){
	if ( viewport().width > 1070 && $('body').hasClass('overflow-hidden') ) {
		closeAllMenuDropdown();
		sideMenu.removeClass('opened');
		$('body').removeClass('overflow-hidden');
	}
}, 250));

function closeAllMenuDropdown(){
	headerExpandedMenuItem.add(headerExpandedMenuItem.find('> ul')).removeClass('expanded');
	headerExpandedMenuItem.find('> a').attr('aria-expanded', 'false');
	headerExpandedMenuItem.find('> ul').stop().slideUp(300);
}

//accessibility (mobile)

let closeMobileMenu = function(){
	$allDropdownNavItems.attr('tabindex', '-1');
	$mobileMenuInput.attr('tabindex', '-1');
	$primaryNavItems.attr('tabindex', '-1');
}

let openMobileMenu = function(){
	$mobileMenuInput.attr('tabindex', '0');
	$primaryNavItems.attr('tabindex', '0');
	$mobileSearchInput.focus();
}

if ( viewport().width <= 1070 ){
	closeMobileMenu();
	$primaryNavItemsWithPopup.attr('aria-haspopup', 'true');
	$primaryNavItemsWithPopup.attr('aria-expanded', 'false');
}

$mobileCloseButton.keydown(function(e) {
	if ( viewport().width <= 1070 ){
		var key = (e.keyCode ? e.keyCode : e.which);
			if (key == 9 ) {
				$(this).parents('.region-primary-menu').find('.navigation.menu--main ul.menu-level-0 > li:first-child > a').focus();
			}
	}
})


$(window).on('resize', debounce(function(){
	$primaryNavItemsWithPopup.attr('aria-haspopup', 'true');
	$primaryNavItemsWithPopup.attr('aria-expanded', 'false');

	if ( viewport().width > 1070 ) {
		closeAllMenuDropdown();
		$mobileMenuInput.attr('tabindex', '0');
		$primaryNavItems.attr('tabindex', '0');
		$allDropdownNavItems.attr('tabindex', '-1');
		$primaryNavItemsNotFirst.attr('tabindex', '-1');
		$('.menu-level-0 .menu-item:first-child > a').attr('tabindex', '0');

		if ( viewport().width > floatSearchMax ){
			$('.region-primary-menu .au-text-input').attr('tabindex', '0');
		} else {
			$('.region-primary-menu .au-text-input').attr('tabindex', '-1');
		}


	} else {
		$allDropdownNavItems.attr('tabindex', '0');
		$primaryNavItemsNotFirst.attr('tabindex', '0');
		closeAllMenuDropdown();
		closeMobileMenu();
	}
}, 250));

//accessibility (desktop)
	if ( viewport().width > 1070 ){
		$allDropdownNavItems.attr('tabindex', '-1');
		$primaryNavItemsNotFirst.attr('tabindex', '-1');
		$primaryNavItemsWithPopup.attr('aria-haspopup', 'true');
		$primaryNavItemsWithPopup.attr('aria-expanded', 'false');
		if ( viewport().width > floatSearchMax ){
			$('.region-primary-menu .au-text-input').attr('tabindex', '0');
		} else {
			$('.region-primary-menu .au-text-input').attr('tabindex', '-1');
		}
	}

	let revealMenu = function(parent, link){
			if(parent.hasClass('menu-item--expanded')){
				parent.add(link.find('> ul')).toggleClass('expanded');
				parent.find('> a').attr("aria-expanded","true");
				link.next().stop().slideToggle(300);
				parent.find('.menu-item a').attr('tabindex', '0');
			}
	}

	$primaryNavItems.keydown(function(e) {
		if ( viewport().width > 1070 ){
			var key = (e.keyCode ? e.keyCode : e.which);

			let $parent = $(this).parent();
			if (key ==39 && $parent.next().length) { //right arrow
				$(this).parents('.menu-level-0').find('.menu-item a').attr("tabindex","-1")
				$parent.next().find('> a').attr("tabindex","0").focus();
				let parent = $parent.next();
				if(!parent.hasClass('expanded')){
					closeAllMenuDropdown();
					revealMenu(parent, parent.find('> a'));
				}

			} else if (key ==37 && $parent.prev().length) { //left arrow
				$(this).parents('.menu-level-0').find('.menu-item a').attr("tabindex","-1")
				$parent.prev().find('> a').attr("tabindex","0").focus();
				let parent = $parent.prev();
				if(!parent.hasClass('expanded')){
					closeAllMenuDropdown();
					revealMenu(parent, parent.find('> a'));
				}

			} else if (key ==40 && $(this).next().length ){ //down arrow
				e.preventDefault();

				let parent = $parent;
				if(!parent.hasClass('expanded')){
					closeAllMenuDropdown();
					revealMenu(parent,$(this));
				}
				$parent.find('> ul > li:first-child > a').focus();
			}
		}
	})

	$allDropdownNavItems.keydown(function(e) {

		if ( viewport().width > 1070 ){
			var key = (e.keyCode ? e.keyCode : e.which);

			let $parent = $(this).parent();
			if (key ==37 &&  $(this).parents('.menu-level-0 > .menu-item').prev() ) { //left arrow
				 $(this).parents('.menu-level-0 > .menu-item').prev().find('>a').focus();

				 let parent = $(this).parents('.menu-level-0 > .menu-item').prev();
				 if(!parent.hasClass('expanded')){
						closeAllMenuDropdown();
						revealMenu(parent, parent.find('> a'));
					}

			} else if (key ==39 && $(this).parents('.menu-level-0 > .menu-item').next()) { //right arrow
				$(this).parents('.menu-level-0 > .menu-item').next().find('>a').focus();

				let parent = $(this).parents('.menu-level-0 > .menu-item').next();
				if(!parent.hasClass('expanded')){
					closeAllMenuDropdown();
					revealMenu(parent, parent.find('> a'));
				}


			} else if (key ==38 && $(this).parents('.menu-level-1').prev().length) { //up arrow
				e.preventDefault();

				if($(this).parent().prev().find('ul').length){
					$(this).parent().prev().find('ul > li:last-child > a').focus();
				} else if($(this).parent().prev().find('> a').length){
					$(this).parent().prev().find('> a').focus();
				} else if( $(this).parents('.menu-level-2').length ){
					$(this).parents('.menu-level-1 > .menu-item').find('> a').focus();
				} else if($(this).parents('.menu-level-2').length){
					$(this).parents('.menu-level-2 > a').focus();
				} else {
					$(this).parents('.menu-level-1').find('> li:last-child > a').focus();
				}

			} else if (key ==40 && $(this).parents('li').next().length ){ //down arrow
				e.preventDefault();

				if($(this).parent().find('ul').length){
					$(this).parent().find('ul > li:first-child > a').focus();
				} else if($(this).parent().next().find('> a').length){
					$(this).parent().next().find('> a').focus();
				} else if( $(this).parents('.menu-level-1').next().length ){
					$(this).parents('.menu-level-1').next().focus();
				} else if($(this).parents('.menu-level-2').length){

					$(this).parents('.menu-level-1 > .menu-item').next().find('> a').focus();
				} else {
					$(this).parents('.menu-level-1').find('> li:first-child > a').focus();
				}

			}
		}
	})
